import * as React from 'react';
import '../../styles/Footer.css';

const cityscape = require('../../images/cityscape-blue.png');

function AdminFooter() {
    let currentYear = new Date().getFullYear();

    const footerStyle = {
        backgroundImage: `url(${cityscape})`,
        backgroundRepeat: 'repeat-x',
        backgroundPosition: 'bottom'
    };

    return (
        <footer style={footerStyle} className="admin-footer">
            <div className="container h-100 d-flex justify-content-center align-items-end">
                <span className="pb-2">&copy; {currentYear} Tour24. All Rights Reserved.</span>
            </div>
        </footer>
    );
}

export default AdminFooter;



// WEBPACK FOOTER //
// ./src/components/common/AdminFooter.tsx